import CustomCard from "components/Atoms/CustomCard"
import React from "react"
import ApprovalList from "./table/ApprovalList"
import ApprovalTableHeader from "./table/ApprovalTableHeader"

const ApprovalTable = () => {
  return (
    <div className="p-3">
      <CustomCard className="vt-dispatch-table-view p-0">
        <ApprovalTableHeader />
        <ApprovalList />
        {/* <CustomReactTable />   */}
      </CustomCard>
    </div>
  )
}

export default ApprovalTable
